import { useEffect } from "react";
import { SignInButton } from "../auth/sign-in/sign-in-button";
import { useUserActions } from "../../services/users/userActions";
import { getAccessToken } from "../../services/msal/msal";
import { ISession } from "../types/user";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { UserState } from "../../types-interfaces/interfaces";
import { setUser, setUserValue } from "../../redux/slices/user/userSlice";
import { useAccount, useMsal } from "@azure/msal-react";
import SignOutButton from "../auth/sign-out/sign-out-button";
import { GetUser } from "../../services/api-ssrr/CollectionManagerAPIClient";

interface UserNameProps {
  className?: string | undefined
}

export const WelcomeName = (props: UserNameProps) => {
  const dispatch = useDispatch()
  const userState = useSelector<RootState, UserState>((state) => state.userState);
  const { accounts, instance } = useMsal();
  const account = useAccount(accounts[0] || {});
  const { setSession } = useUserActions();

  useEffect(() => {
    if (account && account.name && !userState.expiredToken?.status) {
      dispatch(setUserValue({name:'name', value: account.name}))

      const data = async() => {
       var DataApi = await GetUser(account.idToken!,account.username);       
        var session: ISession = {
          isAuthenticated: true,
          user: {
            username: account.name,
            email: account.username
          },
          accessToken: "",
          permissions: []
        };

        if (typeof(DataApi) !== 'string'  ){
          var profile: UserState = {
            email: account.username,
            name: account.name!,
            token: '',
            profiles: DataApi.profiles! ,
            users: [],
            expiredToken: {
              status: false,
              checkDate: ''
            },
            loginInProcess: false
          }

          dispatch(setUser(profile!));

          const token = await getAccessToken().then(data => data.idToken);
          session.accessToken = token;
          setSession(session);
        }
      }
      data();
    } else {      
      dispatch(setUserValue({name:"name", value: ''}));
    }
  //eslint-disable-next-line
  }, [account, dispatch]);

  if (userState.name !== '') {
    return (
      <>
        <SignOutButton instance={instance}/>
      </>
    );
  } else {
    return (
      <SignInButton />
    );
  }
};